import './PrivacySettings.scss';

import { useState } from 'react';

function PrivacySettings() {
    const [isLocationChecked, setIsLocationChecked] = useState(false);
    const [isTwoFactorChecked, setIsTwoFactorChecked] = useState(false);

    return (
        <section className='privacy'>
            <div className='privacy__field'>
                <p className='privacy__field-text'>
                    Location sharing
                </p>

                <div className={`slide-button ${isLocationChecked ? 'checked' : ''}`} onClick={() => setIsLocationChecked(!isLocationChecked)}>
                    <div className="slider"></div>
                </div>
            </div>
            <div className='privacy__field'>
                <p className='privacy__field-text'>
                    Two-factor authentication
                </p>

                <div className={`slide-button ${isTwoFactorChecked ? 'checked' : ''}`} onClick={() => setIsTwoFactorChecked(!isTwoFactorChecked)}>
                    <div className="slider"></div>
                </div>
            </div>
        </section>
    )
}

export default PrivacySettings;
